var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { useTheme } from '../hooks/use-theme';
import { ThemeProvider } from './theme-context';
import { useThemeModeForBg } from '../hooks/use-theme-mode';
import { useActiveThemeMode } from '../hooks/use-active-theme-mode';
export var ThemeModeContext = React.createContext('light');
export var ThemeModeProvider = function (props) {
  var theme = useTheme();
  var newTheme = __assign({}, theme);
  // if auto is given, keep whatever the mode currently us
  if (props.value !== 'auto') {
    newTheme.activeMode = props.value;
  }
  return React.createElement(ThemeProvider, {
    overrides: newTheme
  }, React.createElement(ThemeModeContext.Provider, __assign({}, props), props.children));
};
export var DarkMode = function (_a) {
  var children = _a.children;
  return React.createElement(ThemeModeProvider, {
    value: "dark"
  }, children);
};
export var LightMode = function (_a) {
  var children = _a.children;
  return React.createElement(ThemeModeProvider, {
    value: "light"
  }, children);
};
export var SmartMode = function (_a) {
  var children = _a.children,
    bgColor = _a.bgColor;
  var mode = useThemeModeForBg(bgColor);
  if (mode === 'auto') {
    return children;
  }
  return React.createElement(ThemeModeProvider, {
    value: mode
  }, children);
};
export var ActiveMode = function (_a) {
  var children = _a.children;
  var themeMode = useActiveThemeMode().themeMode;
  var isSystemDarkMode = false;
  if (typeof window !== 'undefined') {
    isSystemDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
  }
  var actualThemeMode = themeMode === 'system' ? isSystemDarkMode ? 'dark' : 'light' : themeMode;
  return React.createElement(ThemeModeProvider, {
    value: actualThemeMode
  }, children);
};
export var withDarkMode = function (Component) {
  return function (props) {
    return React.createElement(DarkMode, null, React.createElement(Component, __assign({}, props)));
  };
};
export var withLightMode = function (Component) {
  return function (props) {
    return React.createElement(LightMode, null, React.createElement(Component, __assign({}, props)));
  };
};